export const STORGE_PREFIXS = {
    CONTRACT_CUSTOMER: 'contracts',
    SAMPLE: 'contracts/samples',
    PARTNER: 'contracts/partners',
    CONTRACT_PROCESS: 'contracts/processes',
    SUBCONTRACT_PROCESS: 'contracts/subcontracts/processes',
    SUBCONTRACT_PARTNER: 'contracts/partners/subcontracts',
    SUBCONTRACT: 'contracts/subcontracts',
    CONTRACT_NEGOTIATION: 'contracts/negotiations',
    EMPLOYEE_DOCUMENTS: 'employees/documents',
    REGULATIONS: 'employees/regulations',
}

export const CONTRACT_PROCESS_STATUS = (t: Function) => [
    { value: 'pending', label: t('pending'), color: 'primary' },
    { value: 'in-progress', label: t('in-progress'), color: 'info' },
    { value: 'completed', label: t('completed'), color: 'success' },
    { value: 'cancelled', label: t('cancelled'), color: 'error' },
    { value: 'rejected', label: t('rejected'), color: 'error' },
]
export const PROCESS_FEEDBACK_STATUS = (t: Function) => [
    { value: 'completed', label: t('completed'), color: 'success' },
    { value: 'in-progress', label: t('in-progress'), color: 'warning' },
    { value: 'rejected', label: t('rejected'), color: 'error' },
]
